import { useQuery } from '@apollo/react-hooks';
import { gql } from '@apollo/client';
import { type GetNominationID } from './types';

type ApplicationFilter = {
  application?: { _id: { eq: string } };
  _id?: { eq: string };
};

export const useGetNominationId = (
  filter: ApplicationFilter,
  sort: any,
): GetNominationID => {
  const { data, loading, error } = useQuery(
    gql`
      query ($filter: NominationFilter, $sort: NominationSort) {
        nominations(filter: $filter, sort: $sort) {
          _id
        }
      }
    `,
    {
      variables: { filter, sort },
    },
  );

  let nominationId = data?.nominations ?? [];
  // TODO: this is not safe. Ensure the valid ones are returned
  nominationId = nominationId.length > 0 ? nominationId[0]._id : '';
  return { nominationId, loading, error };
};
